





































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Collection } from '@/resource/collection/collection.model';
import ModalDelete from '@/components/modals/ModalDelete.vue';
import BeatLoader from 'vue-spinner/src/BeatLoader.vue';

@Component({
  components: {
    ModalDelete,
    BeatLoader,
  },
})
export default class CollectionContainer extends Vue {
  @Prop()
  collection!: Collection;

  @Prop({ default: false })
  showAddQuestionOption!: boolean;

  @Prop()
  isAddQuestionLoading!: boolean;

  @Prop()
  addQuestionToCollection!: (collectionUuid: string) => Promise<void>;

  @Prop()
  fetchCollections: () => void;

  get mainContainerClass() {
    return this.showAddQuestionOption
      ? 'border-1 border-gray-500 border-solid w-full mb-20 py-5 sm:py-10 sm:mb-30 cursor-pointer px-16'
      : 'border-b-1 border-gray-500 border-solid w-full mb-30 sm:mb-40 cursor-pointer px-8 sm:px-16';
  }

  get subContainerClass() {
    return this.showAddQuestionOption
      ? 'flex items-center justify-between w-full h-40 relative overflow-hidden'
      : 'flex items-center justify-between w-full mb-16 sm:mb-20 h-40 relative overflow-hidden';
  }

  showDeleteCollection = false;
  deleteTitle = 'Delete collection';
  deleteDescription = `Are you sure you want to delete this collection? 
  You will not be able to recover this collection.`;

  isLoading = false;

  get collectionName() {
    // TODO truncate
    if (this.collection) {
      return this.collection.name;
    } else {
      return '';
    }
  }

  get showAddButton() {
    if (this.isAddQuestionLoading && this.isLoading) {
      return true;
    } else if (!this.isAddQuestionLoading && !this.isLoading) {
      return true;
    } else {
      return false;
    }
  }

  collectionClicked() {
    this.$router.push(`/collections/${this.collection.uuid}`);
  }

  addQuestionsClicked() {
    this.$router.push(`/subjects/mathematics`);
  }

  async addQuestionClicked() {
    if (this.isLoading) return;
    if (this.isAddQuestionLoading) return;

    this.isLoading = true;
    await this.addQuestionToCollection(this.collection.uuid);

    this.isLoading = false;
  }

  deleteCollectionClicked() {
    this.showDeleteCollection = true;
  }

  closeCollectionDelete(isDeleted = false) {
    if (isDeleted) {
      this.fetchCollections();
    }
    this.showDeleteCollection = false;
  }
}
